/**
 * 🐋 Firebase Configuration - Cetalingua FM Admin Panel
 */

import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

// ========================================
// 🔧 TOGGLE THIS TO SWITCH ENVIRONMENTS
// ========================================
const USE_EMULATORS = true;  // Set to false for PRODUCTION, true for EMULATORS
// ========================================

// TODO: Replace with your Firebase config
// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBP5CJ68gdU3XqvGqnR1Er1r8pAAYmQgYc",
  authDomain: "cetalingua-fm.firebaseapp.com",
  projectId: "cetalingua-fm",
  storageBucket: "cetalingua-fm.firebasestorage.app",
  messagingSenderId: "145613175220",
  appId: "1:145613175220:web:195fc0403f6ebbfc735ae1"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Connect to emulators only if USE_EMULATORS is true
if (USE_EMULATORS && typeof window !== 'undefined') {
  const hostname = window.location.hostname;
  
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    console.log('🔧 Connecting to Firebase Emulators...');
    
    const emulatorHost = '127.0.0.1';

    connectFunctionsEmulator(functions, emulatorHost, 5001);
    connectFirestoreEmulator(db, emulatorHost, 8080);
    connectAuthEmulator(auth, `http://${emulatorHost}:9099`, { disableWarnings: true });
    connectStorageEmulator(storage, emulatorHost, 9199);
    
    console.log('✅ Connected to emulators');
  }
} else {
  console.log('🚀 Using PRODUCTION Firebase');
}

export default app;
